export const validatePhone = (value: string) => {
  const isValid = !value || !value.includes('_')
  return value && !isValid && 'e.g. (123)456-7890'
}
